import $ from "jquery";
import Panzoom from "@panzoom/panzoom/dist/panzoom";

(function ($) {

    $('.section-gallery').each(function () {

        $('a.section-gallery__item').colorbox({

            transition: 'fade',
            current: '({current} / {total})',

            slideshow: false,

            maxHeight: '95%',
            maxWidth: '95%',

            rel: function () {
                return $(this).attr('rel');
            },


            onComplete: function () {

                const img =
                    $('#cboxLoadedContent img')[0];

                if (!img) return;


                const panzoom =
                    Panzoom(img, {
                        maxScale: 5,
                        minScale: 1,
                        contain: 'outside'
                    });


                img.parentElement.addEventListener(
                    'wheel',
                    panzoom.zoomWithWheel
                );



                // Indicateur zoom
                if (!$('.gallery-zoom-hint').length) {

                    $('#colorbox').append(`
                        <div class="gallery-zoom-hint">
                            🖱️ Utilisez la molette pour zoomer
                            <br>
                            ✋ Glissez pour déplacer
                        </div>
                    `);


                    setTimeout(() => {

                        $('.gallery-zoom-hint')
                            .addClass('is-hidden');

                    }, 1000);

                }

            },


            onClosed: function () {

                $('.gallery-zoom-hint')
                    .remove();

            }

        });

    });

})(jQuery);